import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import {
    StudentEndInfoBoxComponent
} from "@app/shared-change-offer/info-boxes/student-end-info-box/student-end-info-box.component";
import {InfoBoxModule} from "@infomaniak/angular-common";

@NgModule({
    declarations: [
        StudentEndInfoBoxComponent,
    ],
    imports: [CommonModule, TranslocoModule, InfoBoxModule],
    exports: [
        StudentEndInfoBoxComponent,
    ],
})
export class InfoBoxesModule {}
